import { useState, useContext } from 'react';
import BigNumber from 'bignumber.js';
import  { depositFarm } from '../../../blockchain/farms';
import { trunc } from '../../../utils/commons';

import { ToastContext } from '../../../context/toast';

const FarmDepositModal = ({ farmData, isModalActive, onModalClose }) => {
  const { addToast } = useContext(ToastContext);

  const [pendingTx, setPendingTx] = useState(false);
  const [val, setVal] = useState('');

  const userBalance = (mul = 1) => {
    const decimals = farmData.isTokenOnly ? farmData.tokenDecimals : process.env.REACT_APP_DECIMALS;

    return trunc(farmData.userBalance, mul, decimals);
  }

  const setValue = (newValue) => {
    setVal(newValue);
  }

  const onValChange = (evt) => {
    const { target } = evt;
    setVal(target.value);
  }

  const canDeposit = () => {
    const value = new BigNumber(val);
    return !value.isNaN() && value.gt(0) && value.lte(userBalance());
  }

  const handleDeposit = async () => {
    const decimals = farmData.isTokenOnly ? farmData.tokenDecimals : process.env.REACT_APP_DECIMALS;
    const amount = new BigNumber(val).times(new BigNumber(10).pow(decimals)).toFixed();

    let tx;
    try {
      setPendingTx(true);
      tx = await depositFarm(farmData.pid, amount);
      await tx.wait();
      addToast(`${farmData.isTokenOnly ? '' : 'LP '}Token Stake succeeded`, 'is-success');
      setPendingTx(false);
      onModalClose();
    } catch (error) {
      tx = { error: error.data ? error.data.message : error.message };
    }

    if (tx.error !== undefined) {
      console.log('error', tx.error);
      addToast(`${farmData.isTokenOnly ? '' : 'LP '}Token Stake failed`, 'is-danger');
      setPendingTx(false);
    }
  }

  return (
    <div className={`modal ${isModalActive ? 'is-active' : null}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Deposit { farmData.name }</p>
          <button className="delete" aria-label="close" onClick={ onModalClose }></button>
        </header>
        <section className="modal-card-body">
          <div className="buttons is-right mb-0">
            <button className="button is-success is-small is-outlined" onClick={ () => setValue(userBalance(0.25).toFixed()) }>
              25%
            </button>
            <button className="button is-success is-small is-outlined" onClick={ () => setValue(userBalance(0.5).toFixed()) }>
              50%
            </button>
            <button className="button is-success is-small is-outlined" onClick={ () => setValue(userBalance(0.75).toFixed()) }>
              75%
            </button>
            <button className="button is-success is-small is-outlined" onClick={ () => setValue(userBalance().toFixed()) }>
              100%
            </button>
            <button className="button is-text" onClick={ () => setValue(userBalance().toFixed()) }>
              { userBalance().toFormat() } max
            </button>
          </div>
          <div className="field has-addons">
            <div className="control is-expanded">
              <input className="input has-text-right" type="text" placeholder="0" value={ val } onChange={ onValChange } />
            </div>
            <div className="control">
              <button type="button" className="button is-static">
                { farmData.name }
              </button>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-flex-end">
          <button
            onClick={ handleDeposit }
            disabled={ pendingTx || !canDeposit() }
            className={ `button is-success ${pendingTx ? 'is-loading' : ''}` }
          >
            Confirm
          </button>
          <button
            disabled={ pendingTx }
            className="button"
            onClick={ onModalClose }
          >
            Cancel
          </button>
        </footer>
      </div>
    </div>
  );
}

export default FarmDepositModal;
